//メニューボタン
$(function(){
	if (window.matchMedia('(max-width: 990px)').matches) {    
		$(document).on("click", ".gloMenu>.mainMenu>ul>li>p", function() {
			$('.cateChildWrap').removeClass('menuOn');
			$(this).parent().find('.cateChildWrap').addClass('menuOn');
		})
	}
});
$(function(){
	$(document).on("click", ".closeMenu", function() {
		$('.cateChildWrap').removeClass('menuOn');
	})
});
$(function(){
	$(document).on("click", ".menuDrawer>.mainMenu>ul>li>p", function() {
		$(this).parent().find('.cateChildWrap').toggleClass('menuOn');
	})
});

//トップスライダー
var swiperFv = new Swiper(".agsFv", {
	effect: 'fade',
	loop: true,
	SimulateTouch:false,
	autoplay: {
		delay: 6000,
	},
	speed:500,
	pagination: {
		el: ".swiper-pagination",
		clickable: true,
		//renderBullet: function (index, className) {
		//	return '<span class="' + className + '"><svg><circle cx="30" cy="30" r="30"/></svg><b>0'+ (Number(index) + 1) + '</b></span>';
		//},
	},
	breakpoints: {
		801:{
			pagination: {
				//renderBullet: function (index, className) {
				//	return '<span class="' + className + '"><svg><circle cx="35" cy="35" r="35"/></svg><b>0'+ (Number(index) + 1) + '</b></span>';
				//},
			}
		}
	}
});

//クーポンバナー消す
$(function() {
	$(function(){
		$(document).on("click", ".cpnClose", function(){
			$(".bannerCoupon").hide();
		})
	});
});
//セッション期間内はバナー消す
$(function() {
	if (window.matchMedia("(min-width:601px)").matches) {
		$(function(){
			if(sessionStorage.getItem('cbnr') !== 'clear') {
				$('.bannerCoupon').show();
			}
			$('.bannerCoupon .cpnClose').on('click', function () {
				$('.bannerCoupon').hide();
				sessionStorage.setItem('cbnr', 'clear');
			});
		});
	};
});

//クーポンをクリップボードに
$(function() {
	$('.copyBtn').on('click', function(){
		let text = $('.copyText').text();
		let $textarea = $('<textarea></textarea>');
		$textarea.text(text);
		$(this).append($textarea);
		$textarea.select();
		document.execCommand('copy');
		$textarea.remove();
		alert('クーポンコードをコピーしました。\n10,000円以上の利用で1000円OFFを初回限定でご利用いただけます。')
	});
});


//ランキングタブ切り替え
$(function(){
	$('.tabtn:first').addClass('crntTab');
	$('.cnts:first').addClass('crntCnts');
});
document.addEventListener('DOMContentLoaded', function(){
	// タブに対してクリックイベントを適用
	const tabs = document.getElementsByClassName('tabtn');
	for(let i = 0; i < tabs.length; i++) {
		tabs[i].addEventListener('click', tabSwitch);
	}

	// タブをクリックすると実行する関数
	function tabSwitch(){
		// タブのclassの値を変更
		document.getElementsByClassName('crntTab')[0].classList.remove('crntTab');
		this.classList.add('crntTab');
		// コンテンツのclassの値を変更
		document.getElementsByClassName('crntCnts')[0].classList.remove('crntCnts');
		const arrayTabs = Array.prototype.slice.call(tabs);
		const index = arrayTabs.indexOf(this);
		document.getElementsByClassName('cnts')[index].classList.add('crntCnts');
	};
});

//ランキングもっとボタン
$(function(){
	$(document).on("click", ".rankMoreBtn", function() {
		$(this).parent().find('.item_detail:nth-child(n+11)').fadeToggle(500);
		$(this).toggleClass('rankCloseBtn');
		if (window.matchMedia('(max-width: 990px)').matches) {
			$(this).parent().find('.item_detail:nth-child(10)').fadeToggle(500);
		}
	})
});

//QA
$(function(){
	$('.openBtn').on('click', function () {
		$(this).parent().toggleClass('openItem');
		$(this).toggleClass('openBtnOn');
	})
});
$(function(){
	$('.pagsQaDetail dt').on('click', function () {
		$(this).find('+dd').fadeToggle(500);
		$(this).find('span').toggleClass('qaOpen');
	})
});


//プレミアム背景
$(function(){
    if(document.URL.match("/p9")) {
		$('.section-template--16837864915081__main-padding').css('background-color','#e8e8e8');
    }
});

//年齢確認
function ageCheckControl(){
	var age=$('.product__text').text();
	if(age.indexOf('D3-')>=0||age.indexOf('D1-')>=0){$(".ageCheckBox").show();
		$('#ProductSubmitButton-template--21004475105417__main,[id^="ProductSubmitButton-template--"][id$="__main"],#buyNow').prop("disabled",!$('#ageCheck').prop('checked'));
		$(".shopify-payment-button__button").prop("disabled",!$('#ageCheck').prop('checked'));
	}else{
		$('.shopify-payment-button__button').show();
	}
}
//初回
$(window).on('load',ageCheckControl);
//チェック変更
$(document).on('change','#ageCheck',ageCheckControl);
//DOM変化監視（ここが本命）
const observer=new MutationObserver(function(){ageCheckControl();});
observer.observe(document.body,{childList:true,subtree:true});

//トップスライダー
var slider = new Swiper ('.topSlider', {
	effect: 'fade',
	speed: 700,
	autoplay: {
        delay: 5000,
    },   
	spaceBetween: 0,
	slidesPerView: 1,
	centeredSlides: true,
	centerInsufficientSlides: true,
	loop: true,
	preloadImages: false,
	lazy: { loadPrevNext: true },
	pagination: {
		el: '.swiper-pagination',
	}
});

//wiserへバッヂの追加
(function() {
	let retryCount = 0;
	const maxRetry = 40;
	function insertWiserBadges() {
		const cards = document.querySelectorAll('.ws_card_wrapper');
		console.log('cards found:', cards.length);
		if (!cards.length) return false;
		cards.forEach(card => {
			if (card.classList.contains('badge-checked')) return;
			const header = card.querySelector('.ws_card_header');
			if (!header) return;
			const link = card.querySelector('.ws_product_card_image_link, .ws-product-title-link');
			if (!link) return;
			const url = link.getAttribute('href') || '';
			if (!url) return;
			let badgeHTML = '';
			if (url.includes('-card')) {
				badgeHTML = `
					<div class="productTypeBadgeWrap">
						<div class="productTypeBadge productCard--card">
							<p>紙カード</p>
						</div>
					</div>
				`;
			} else if (url.includes('-dgtl')) {
				badgeHTML = `
					<div class="productTypeBadgeWrap">
						<div class="productTypeBadge productCard--dgtl">
							<p>eギフト</p>
						</div>
					</div>
				`;
			}
			if (badgeHTML) {
				header.insertAdjacentHTML('afterend', badgeHTML);
				card.classList.add('badge-checked');
			}
		});
		return true;
	}
	const timer = setInterval(() => {
		retryCount++;
		const success = insertWiserBadges();
		if (success || retryCount >= maxRetry) {
			clearInterval(timer);
			console.log('badge script stopped');
		}
	}, 5000);
})();

//searchaniseのバッヂ処理
document.addEventListener('DOMContentLoaded', function () {

	function addProductTypeBadges(container = document) {
		const products = container.querySelectorAll('.snize-product');
		console.log('[badge] 対象商品数:', products.length);

		products.forEach((product) => {
			if (product.querySelector('.productTypeBadgeWrap')) return;

			const link = product.querySelector('a.snize-view-link');
			const overhidden = product.querySelector('.snize-overhidden');

			if (!link || !overhidden) {
				console.log('[badge] link or overhidden not found', product);
				return;
			}

			const href = link.getAttribute('href') || '';
			const path = href.split(/[?#]/)[0];

			let type = null;
			if (path.endsWith('-dgtl')) {
				type = 'dgtl';
			} else if (path.endsWith('-card')) {
				type = 'card';
			}

			if (!type) {
				console.log('[badge] タイプ判定できず:', href);
				return;
			}

			const badgeWrap = document.createElement('div');
			badgeWrap.className = 'productTypeBadgeWrap';

			if (type === 'dgtl') {
				badgeWrap.innerHTML = `
					<div class="productTypeBadge productCard--dgtl">
						<p>eギフト</p>
					</div>
				`;
			} else {
				badgeWrap.innerHTML = `
					<div class="productTypeBadge productCard--card">
						<p>紙カード</p>
					</div>
				`;
			}

			overhidden.parentNode.insertBefore(badgeWrap, overhidden);
			console.log('[badge] 追加しました:', href);
		});
	}

	// 監視は document.body 全体を対象に、最初から開始
	const snizeObserver = new MutationObserver(function () {
		addProductTypeBadges();
	});
	snizeObserver.observe(document.body, { childList: true, subtree: true });

	// 念のため2秒後にも実行
	setTimeout(function () {
		addProductTypeBadges();
	}, 2000);

});


//絞り込みの名称置換
const map={
	'type_card':'紙カード',
	'type_egift':'eギフト'
};
function replaceText() {
	document.querySelectorAll('.facet-checkbox__text-label,.active-facets__button-inner').forEach(span=>{
		span.childNodes.forEach(node=>{
			if(node.nodeType===3){
				let text=node.textContent;
				for(const key in map){
					text = text.replace(new RegExp(key,'g'), map[key]);
				}
				node.textContent = text;
			}
		});
	});
}
// 初回実行
document.addEventListener('DOMContentLoaded', replaceText);
// facets内クリックで再発火
document.addEventListener('click', (e) => {
	if (e.target.closest('.facets__disclosure')) {
		// DOM更新後に実行（重要）
		setTimeout(replaceText, 3000);
	}
});



//￥マークを小さく
document.addEventListener('DOMContentLoaded', () => {
	const target = document.body;
	const markClass = 'enMark';
	const excludeSelector = `script, style, textarea, input, select, option, .${markClass}`;

	function wrapYen(root = target) {
		if (!root || !root.nodeType) return;
		const walker = document.createTreeWalker(
			root,
			NodeFilter.SHOW_TEXT,
			{
				acceptNode(node) {
					if (!node.nodeValue.includes('¥')) return NodeFilter.FILTER_REJECT;
					if (node.parentElement?.closest(excludeSelector)) return NodeFilter.FILTER_REJECT;
					return NodeFilter.FILTER_ACCEPT;
				}
			}
		);

		const nodes = [];
		while (walker.nextNode()) nodes.push(walker.currentNode);

		nodes.forEach(node => {
			if (!node.parentNode) return;
			const frag = document.createDocumentFragment();
			node.nodeValue.split(/(¥)/).forEach(text => {
				if (text === '¥') {
					const span = document.createElement('span');
					span.className = markClass;
					span.textContent = '¥';
					frag.appendChild(span);
				} else {
					frag.appendChild(document.createTextNode(text));
				}
			});
			node.parentNode.replaceChild(frag, node);
		});
	}

	wrapYen();

	const observer = new MutationObserver(mutations => {
		mutations.forEach(mutation => {
			mutation.addedNodes.forEach(node => {
				if (node.nodeType === 1) wrapYen(node);
				if (node.nodeType === 3 && node.nodeValue.includes('¥') && node.parentNode) wrapYen(node.parentNode);
			});
		});
	});

	observer.observe(target, {
		childList: true,
		subtree: true
	});
});






// ブランドページタイプバッヂ
document.querySelectorAll('.gp-product-title-link-wrapper[href]').forEach(link => {
	const url = new URL(link.href);
	const pathname = url.pathname.replace(/\/$/, '');
	if (pathname.endsWith('-card')) {
		link.classList.add('brandCardbadge');
	}
	if (pathname.endsWith('-dgtl')) {
		link.classList.add('brandEgiftbadge');
	}
});



//商品ページのオプション画像のポップアップ
document.addEventListener('click',e=>{
	const link=e.target.closest('.productPopup');
	if(!link) return;
	const title=link.getAttribute('data-title') || '';
	e.preventDefault();
	// ここも変更しないとバグる
	document.querySelectorAll('.productPopupOverlay').forEach(el=>el.remove());
	const src=link.getAttribute('href');
	const overlay=document.createElement('div');
	overlay.className='productPopupOverlay';
	overlay.innerHTML=`
		<span class="productPopupClose">&times;</span>
		<div class="productPopupImg">
			<img src="${src}">
			<p>${title}</p>
		</div>`;
	overlay.onclick=e=>{
		if(e.target===overlay||e.target.classList.contains('productPopupClose')) overlay.remove();
	};
	document.body.appendChild(overlay);
});



//絞り込みをしたページにサブタイトルを追加
// const params = new URLSearchParams(window.location.search);
// // filter_ で始まるパラメータの値を集める
// const filterValues = [];
// for (const [key, value] of params.entries()) {
//   if (key.startsWith('filter_')) {
//     filterValues.push(value);
//   }
// }

// if (filterValues.length > 0) {
//   const titleEl = document.querySelector('.collection-hero__title');

//   if (titleEl) {
//     const newDiv = document.createElement('div');
//     newDiv.className = 'collection-hero__filter-summary'; // 任意のクラス名
//     newDiv.textContent = filterValues.join('・'); // textContentでXSS対策

//     // titleEl の直後に挿入(=兄弟要素として下に追加)
//     titleEl.insertAdjacentElement('afterend', newDiv);
//   }
// }